<div class="col-sm-2 settings-amenities-filter">
    <div class="settings-amenities-filter_view-part" (click)="showDropdown = !showDropdown">Filter</div>
    <div class="settings-amenities-filter_dropdown" [hidden]="!showDropdown">
        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="dailyCheckbox" #dailyCheckbox (change)="changeFilter()">
                <label for="dailyCheckbox"><svg-checked></svg-checked></label>
                <span>Daily</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="timeSlotCheckbox" #timeSlotCheckbox (change)="changeFilter()">
                <label for="timeSlotCheckbox"><svg-checked></svg-checked></label>
                <span>Time Range</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="hourlyCheckbox" #hourlyCheckbox (change)="changeFilter()">
                <label for="hourlyCheckbox"><svg-checked></svg-checked></label>
                <span>Hourly</span>
            </label>
        </div>

        <hr>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="activeCheckbox" #activeCheckbox (change)="changeFilter()">
                <label for="activeCheckbox"><svg-checked></svg-checked></label>
                <span>Active</span>
            </label>
        </div>

        <div class="m-b-xs filter-checkbox">
            <label class="img-checkbox">
                <input type="checkbox" id="inactiveCheckbox" #inactiveCheckbox (change)="changeFilter()">
                <label for="inactiveCheckbox"><svg-checked></svg-checked></label>
                <span>Inactive</span>
            </label>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/settings-amenities-filter/settings-amenities-filter.component.html